module.exports = require("@formatjs/intl-pluralrules/polyfill");